import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import Button from 'modules/_shared/components/Buttons';
import { useEncumbranceDetailsPage } from '../context/EncumbranceDetailsPageContext';

const CoOwnersHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useEncumbranceDetailsPage();

  const buttonDisabled =
    data.isReadOnly || data.coOwnersPercentage >= 100 || !data.isAdmin;

  return (
    <div className="coOwners-header">
      <div>
        <h2 className="coOwners-header__title">{t('CoOwners')}</h2>
        <p className="coOwners-header__subtitle">
          {`${t('HasCoOwners', {
            count: data.coOwnersTotal,
          })}`}
        </p>
      </div>
      <Button
        onClick={actions.handleAddCoOwner}
        icon="ni ni-plus"
        text={t('AddCoOwner')}
        disabled={buttonDisabled}
      />
    </div>
  );
};

export default CoOwnersHeader;
